"use strict";

define('language/all_languages',["./en-US"], function () {
  return arguments;
});

